import React, { useEffect, useState } from "react";
import { Box, Typography, TextField, Paper, Button, } from "@mui/material";
import LogoutIcon from '@mui/icons-material/Logout';
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useLocation } from "react-router-dom";
import { getAllUserAction } from '../../store/actions';
import NavBar from '../Layout/NavBar';

const Profile = () => {
    const [user, setUser] = useState({ name: '', mobileNumber: '' });
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    const { successData, loading } = useSelector((state) => state.getAllUserReducer || {});
    const users = React.useMemo(() => {
        if (Array.isArray(successData)) return successData;
        if (Array.isArray(successData?.data?.users)) return successData.data.users;
        return [];
    }, [successData]);

    useEffect(() => {
        const userData = JSON.parse(localStorage.getItem('userDetails'));
        if (userData) {
            setUser({
                name: userData.name || '',
                mobileNumber: userData.mobileNumber || userData.mobile || '',
            });
        }
        dispatch(getAllUserAction());
    }, [dispatch]);

    const handleLogout = () => {
        localStorage.clear();
        navigate('/');
    };

    return (
        <>
            <NavBar hideLogin={location.pathname === '/profile'} />
            <Box sx={{ maxWidth: 400, mx: 'auto', mt: 8, p: 3 }}>
                <Typography variant="h5" sx={{ color: '#4F46E5', fontWeight: 700, mb: 3 }}>PROFILE</Typography>
                <Paper elevation={2} sx={{ p: 3, borderRadius: 2, mb: 3 }}>
                    <TextField
                        label="Full Name"
                        value={user.name}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        sx={{ mb: 2 }}
                    />
                    <TextField
                        label="Mobile Number"
                        value={user.mobileNumber}
                        InputProps={{ readOnly: true }}
                        fullWidth
                        sx={{ mb: 2 }}
                    />
                    <Button
                        variant="contained"
                        sx={{ backgroundColor: '#3A349B' }}
                        startIcon={<LogoutIcon />}
                        onClick={handleLogout}
                        fullWidth
                    >
                        LOGOUT
                    </Button>
                </Paper>
            </Box>
        </>
    );
};

export default Profile;
   